import React from 'react';
import Grid from '@mui/material/Grid';
import Nation from './Nation.js';
import { CATEGORIES } from './Categories.js';

const Body = () => {
  return (
    <div className="stickerContainer">
      {CATEGORIES.map((nation) => (
        <Nation key={nation} nation={nation} />
      ))}
      <div>
        <p style={{ fontSize: 'x-small' }}>
          Unauthorized use, reproduction, or distribution of any content from this website, including stickers and related materials, is prohibited.
        </p>
      </div>
    </div>
  );
};

export default Body
